import React from "react";
import Navbar from "../components/Navbar";
import Home from "../components/Home";
import Aside from "../components/Aside";
import Footer from "../components/Footer";

const HomePage = () => {
  return (
    <>
      <Navbar />
      <Home />
      <Aside />
      <Footer />
    </>
  );
};

export default HomePage;
